import { useMapEvents } from 'react-leaflet';

const MapEventHandler = ({ onMapMove, defaultBounds }) => {
  useMapEvents({
    move: (e) => {
      const b = e.target.getBounds();
      const sw = b.getSouthWest();
      const ne = b.getNorthEast();
      console.log('Map move bounds (SW, NE):', [sw.lat, sw.lng], [ne.lat, ne.lng]);
    },
    moveend: () => {
      console.log('Map moveend event triggered');
      if (onMapMove) {
        onMapMove();
      }
    },
    zoomend: () => {
      console.log('Map zoomend event triggered');
      if (onMapMove) {
        onMapMove();
      }
    },
  });

  return null; // This component doesn't render anything
};

export default MapEventHandler;
